import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType, TextTypePropType } from 'ui-components/components/text';

import { CurrencyPropType } from '../../../../../prop-types/currency';
import LabelProviderLogo from '../../label-provider-logo/label-provider-logo';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';
import Rate from '../../rate/rate';

import style from './rate-details.module.less';

const RateDetails = ({
  fulfillmentPlanId,
  labelProviderId,
  fillProviderId,
  totalCost,
  hideCostReview = false,
  isDisabled = false,
  isThirdPartyBilling = false,
  hasProvidedRate = false,
  disabledMessage,
  carrierLogoClassName = '',
  rateAmountTextType = TextType.H2,
  refreshButtonClassName = '',
  refreshIconClassName = '',
}) => {
  const costReviewFulfillmentPlanIds = useMemo(() => {
    return hideCostReview ? undefined : [fulfillmentPlanId];
  }, [fulfillmentPlanId, hideCostReview]);

  return (
    <FlexRow className={style['rate-details']}>
      {isDisabled ? (
        <Text className={style['missing-service-selection']} role='note' textType={TextType.Paragraph} value={disabledMessage} />
      ) : (
        <>
          <LabelProviderLogo className={carrierLogoClassName} fillProviderId={fillProviderId} labelProviderId={labelProviderId} />
          <Rate
            costReviewFulfillmentPlanIds={costReviewFulfillmentPlanIds}
            fulfillmentPlanId={fulfillmentPlanId}
            hasProvidedRate={hasProvidedRate}
            isThirdPartyBilling={isThirdPartyBilling}
            rate={totalCost}
            rateAmountTextType={rateAmountTextType}
            refreshButtonClassName={refreshButtonClassName}
            refreshIconClassName={refreshIconClassName}
          />
        </>
      )}
    </FlexRow>
  );
};

export default RateDetails;

RateDetails.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  fillProviderId: PropTypes.string,
  labelProviderId: PropTypes.string,
  totalCost: CurrencyPropType,
  hideCostReview: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isThirdPartyBilling: PropTypes.bool,
  hasProvidedRate: PropTypes.bool,
  disabledMessage: MessageDescriptorPropType,
  carrierLogoClassName: PropTypes.string,
  rateAmountTextType: TextTypePropType,
  refreshButtonClassName: PropTypes.string,
  refreshIconClassName: PropTypes.string,
};
